import FieldsetContainer from 'components/blocks/Delta/Inputs/Containers/FieldsetContainer';
import AccordionForm from 'components/blocks/ManagementNewForms/Accordion/AccordionForm';
import FormDatosPersonales from 'components/blocks/ManagementNewForms/ButtonGroups/FormDatosPersonales';
import FormObservaciones from 'components/blocks/ManagementNewForms/Inputs/FormObservaciones';
import { useEffect, useState } from 'react'
import { FormProvider, set, useFieldArray, useForm } from 'react-hook-form';
import Loader from 'components/blocks/Loader/Loader';
import FormBotonSubmit from 'components/blocks/ManagementNewForms/Inputs/FormInputSubmit';
import useCreateDeclaracionTrabajadorCuentaPropia from 'services/record/DeclaracionTrabajadorCuentaPropia/useCreateDeclaracionTrabajadorCuentaPropia';
import useUpdateDeclaracionTrabajadorCuentaPropiaByID from 'services/record/DeclaracionTrabajadorCuentaPropia/useUpdateDeclaracionTrabajadorCuentaPropia';
import InputTextIntegration from 'components/blocks/ManagementNewForms/Inputs/InputTextIntegration';
import FormInfoCreateUpdate from 'components/blocks/ManagementNewForms/Inputs/FormInfoCreateUpdate';

const DeclaracionTrabajadorCuentaPropia = ({ info, dataUser, onSuccess }: { info: boolean; dataUser: any, onSuccess?: () => void }) => {


    const formMethods = useForm();
    const { register, handleSubmit, setError, formState: { errors }, setValue, watch, reset, control, getValues } = formMethods;
    const { createDeclaracionTrabajadorCuentaPropia, dataCreateDeclaracionTrabajadorCuentaPropia, errorCreateDeclaracionTrabajadorCuentaPropia, loadingCreateDeclaracionTrabajadorCuentaPropia, successCreateDeclaracionTrabajadorCuentaPropia } = useCreateDeclaracionTrabajadorCuentaPropia();
    const { dataUpdateDeclaracionTrabajadorCuentaPropiaById, errorUpdateDeclaracionTrabajadorCuentaPropiaById, loadingUpdateDeclaracionTrabajadorCuentaPropiaById, successUpdateDeclaracionTrabajadorCuentaPropiaById, updateDeclaracionTrabajadorCuentaPropiaById } = useUpdateDeclaracionTrabajadorCuentaPropiaByID();
    const [datosAPI, setDatosAPI] = useState(dataUser);
    const [bloquearEnvio, setBloquearEnvio] = useState<boolean>(false);
    const [loader, setLoader] = useState(false);



    const adaptApiResponseToDefaultValues = (data: any) => {
        //console.log(data)
        if (data) {
            const getValue = (...values: any[]) => values.find(v => v !== undefined && v !== null);
            const datosPersonales = getValue(data?.DatosPersonales, data?.datosPersonales) || {};
            const declaracionTrabajador = getValue(data?.DeclaracionTrabajador, data?.declaracionTrabajador) || {};
            const nombre = getValue(datosPersonales?.Nombre, datosPersonales?.nombre, "");
            const apellido1 = getValue(datosPersonales?.Apellido1, datosPersonales?.apellido1, "");
            const apellido2 = getValue(datosPersonales?.Apellido2, datosPersonales?.apellido2, "");

            reset({
                DatosPersonales: {
                    SolicitanteNombre: nombre,
                    SolicitanteApellido1: apellido1,
                    SolicitanteApellido2: apellido2,
                    SolicitanteIPF: getValue(datosPersonales?.IPF, datosPersonales?.ipf, ""),
                    SolicitanteIPFTipo: getValue(datosPersonales?.IPFTipo, datosPersonales?.ipfTipo)?.toString() || "1",
                    SolicitanteNombreCompleto: `${nombre} ${apellido1} ${apellido2}`.trim(),
                    SolicitanteTelefono: getValue(datosPersonales?.Telefono, datosPersonales?.telefono, ""),
                    SolicitanteFijo: getValue(datosPersonales?.Fijo, datosPersonales?.fijo, ""),
                    SolicitanteDomicilio: getValue(datosPersonales?.Domicilio, datosPersonales?.domicilio, ""),
                    SolicitanteCodigoPostal: getValue(datosPersonales?.CodigoPostal, datosPersonales?.codigoPostal, ""),
                    SolicitanteProvincia: getValue(datosPersonales?.CodigoProvincia, datosPersonales?.codigoProvincia, ""),
                    SolicitanteProvinciaDescripcion: getValue(datosPersonales?.Provincia, datosPersonales?.ProvinciaDescripcion, datosPersonales?.provinciaDescripcion, ""),
                    SolicitanteComunidadCodigo: getValue(datosPersonales?.ComunidadCodigo, datosPersonales?.CodigoLocalidad, datosPersonales?.codigoLocalidad, ""),
                    SolicitanteComunidadCodigoDescripcion: getValue(datosPersonales?.ComunidadCodigoDescripcion, datosPersonales?.LocalidadDescripcion, datosPersonales?.localidadDescripcion, ""),
                    SolicitanteNumeroSS: getValue(
                        datosPersonales?.NumeroSeguridadSocial,
                        datosPersonales?.numeroSeguridadSocial,
                        data?.NumeroSeguridadSocial,
                        data?.numeroSeguridadSocial,
                        ""
                    ),
                },
                Declaracion: {
                    ActividadEconomica: getValue(declaracionTrabajador?.ActividadLaboral, declaracionTrabajador?.actividadLaboral, ""),
                    Domicilio: getValue(declaracionTrabajador?.Domicilio, declaracionTrabajador?.domicilio, ""),
                    Regimen: getValue(declaracionTrabajador?.EstaEnRegimenEspecial, declaracionTrabajador?.estaEnRegimenEspecial, ""),
                    ReduccionJornada: getValue(declaracionTrabajador?.JornadaTrabajo, declaracionTrabajador?.jornadaTrabajo, ""),
                    FechaInicio: getValue(declaracionTrabajador?.FechaInicio, declaracionTrabajador?.fechaInicio, ""),
                }
            })
        }

    }

    useEffect(() => {
        setDatosAPI(dataUser);
    }, [dataUser]);

    useEffect(() => {
        adaptApiResponseToDefaultValues(dataUser);
    }, [dataUser]);




    const onSubmit = async (data: any) => {
        console.log(data);
        setLoader(true);

        let prestacionId = dataUser?.PrestacionId || null;

        const datosEnvio = {
            // IDENTIFICACIÓN
            Id: dataUser?.Id || null,
            ExternalId: dataUser?.ExternalId || 0,
            PersonaId: dataUser?.PersonaId || 0,
            UsuarioId: dataUser?.UsuarioId || null,
            ExpedienteId: dataUser?.ExpedienteId || null,
            PrestacionId: prestacionId,

            Acepto: data?.Acepto ?? false,

            // -----------------------------------
            // DATOS PERSONALES
            // -----------------------------------
            datosPersonales: {
                nombre: dataUser?.DatosPersonales?.Nombre ?? dataUser?.datosPersonales?.nombre ?? "",
                apellido1: dataUser?.DatosPersonales?.Apellido1 ?? dataUser?.datosPersonales?.apellido1 ?? "",
                apellido2: dataUser?.DatosPersonales?.Apellido2 ?? dataUser?.datosPersonales?.apellido2 ?? "",
                ipf: dataUser?.DatosPersonales?.IPF ?? dataUser?.datosPersonales?.ipf ?? "",
                ipfTipo: dataUser?.DatosPersonales?.IPFTipo ?? dataUser?.datosPersonales?.ipfTipo ?? 1,
                telefono: dataUser?.DatosPersonales?.Telefono ?? dataUser?.datosPersonales?.telefono ?? "",
                fijo: dataUser?.DatosPersonales?.Fijo ?? dataUser?.datosPersonales?.fijo ?? "",
                domicilio: dataUser?.DatosPersonales?.Domicilio ?? dataUser?.datosPersonales?.domicilio ?? "",
                codigoPostal: dataUser?.DatosPersonales?.CodigoPostal ?? dataUser?.datosPersonales?.codigoPostal ?? "",
                provinciaDescripcion: dataUser?.DatosPersonales?.ProvinciaDescripcion ?? dataUser?.DatosPersonales?.Provincia ?? dataUser?.datosPersonales?.provinciaDescripcion ?? "",
                codigoProvincia: dataUser?.DatosPersonales?.CodigoProvincia ?? dataUser?.datosPersonales?.codigoProvincia ?? "",
                codigoLocalidad: dataUser?.DatosPersonales?.CodigoLocalidad ?? dataUser?.datosPersonales?.codigoLocalidad ?? "",
                localidadDescripcion: dataUser?.DatosPersonales?.LocalidadDescripcion ?? dataUser?.datosPersonales?.localidadDescripcion ?? "",
                numeroSeguridadSocial: dataUser?.DatosPersonales?.NumeroSeguridadSocial ?? dataUser?.datosPersonales?.numeroSeguridadSocial ?? ""
            },
            DeclaracionTrabajador: {
                ActividadLaboral: data?.Declaracion?.ActividadEconomica || "",
                Domicilio: data?.Declaracion?.Domicilio || "",
                EstaEnRegimenEspecial: data?.Declaracion?.Regimen || "",
                JornadaTrabajo: data?.Declaracion?.ReduccionJornada !== "" && data?.Declaracion?.ReduccionJornada !== undefined
                    ? Number(data?.Declaracion?.ReduccionJornada)
                    : null,
                FechaInicio: data?.Declaracion?.FechaInicio || null,
            }
        }

        if (info) {
            await createDeclaracionTrabajadorCuentaPropia(dataUser?.UsuarioId.toString(), datosEnvio, onSuccess)
            setBloquearEnvio(true);
        } else {
            await updateDeclaracionTrabajadorCuentaPropiaById(dataUser?.Id, dataUser?.Id, datosEnvio)
            setBloquearEnvio(true);
        }


        setTimeout(() => {
            setLoader(false); //tiempo cargar DOM
        }, 500);
    };





    return (
        <FormProvider {...formMethods}>
            <div className="container form--simple-styled" id="formDeltawithoutleave">

                {/* ////////////// OBSERVACIONES DEL GESTOR A LA SOLICITUD ////////////// */}
                <FormObservaciones observaciones={datosAPI?.Observaciones} titulo={'Observaciones del Gestor a la Solicitud'} />

                <Loader activeLoader={loader || loadingCreateDeclaracionTrabajadorCuentaPropia || loadingUpdateDeclaracionTrabajadorCuentaPropiaById} label="Cargando Formulario"></Loader>








                {/* //////////////////////////// COMIENZO FORMULARIO //////////////////////////// */}
                {/* ////////////// DATOS DEL TRABAJADOR ////////////// */}
                <FormInfoCreateUpdate
                    isCreate={info}
                    estadoFormulario={datosAPI?.EstadoFormulario ?? datosAPI?.estadoFormulario ?? dataUser?.EstadoFormulario ?? dataUser?.estadoFormulario}
                    estadoFormularioDescripcion={datosAPI?.EstadoFormularioDescripcion ?? datosAPI?.estadoFormularioDescripcion ?? dataUser?.EstadoFormularioDescripcion ?? dataUser?.estadoFormularioDescripcion}
                    fechaActualizacionEstado={datosAPI?.FechaActualizacionEstado ?? datosAPI?.fechaActualizacionEstado ?? dataUser?.FechaActualizacionEstado ?? dataUser?.fechaActualizacionEstado}
                />
                <FieldsetContainer legend="" disabled={false}>

                    <p className='mb-2 text-left parra-bold'>D./Dña
                        <InputTextIntegration
                            name="DatosPersonales.SolicitanteNombreCompleto"
                            inputType={1}
                            disabled={true}
                            minWidth={300}
                        />

                        con número de afiliación a la Seguridad Social
                        <InputTextIntegration
                            name="DatosPersonales.SolicitanteNumeroSS"
                            inputType={1}
                            disabled={true}
                        />
                        con DNI/NIF/pasaporte/NIE número
                        <InputTextIntegration
                            name="DatosPersonales.SolicitanteIPF"
                            inputType={1}
                            disabled={true}
                        />
                        y domicilio en:
                        <InputTextIntegration
                            name="DatosPersonales.SolicitanteDomicilio"
                            inputType={1}
                            disabled={true}
                            minWidth={500}
                        />
                        <div className='m-3'></div>
                    </p>


                </FieldsetContainer>
                <div className='m-3'></div>



                <FieldsetContainer legend="" disabled={false}>

                    <div>
                        <p className='fw-bold mb-4'>DECLARA:</p>
                        <p className='mb-3'>Que su actividad económica, oficio o profesion es
                            <InputTextIntegration
                                name="Declaracion.ActividadEconomica"
                                inputType={1}
                                req='Es necesaria la actividad económica'
                                minWidth={200}
                                disabled={false}
                            />
                            con domicilio en
                            <InputTextIntegration
                                name="Declaracion.Domicilio"
                                inputType={1}
                                minWidth={300}
                                req='Es necesario el Domicilio'
                                disabled={false}
                            />
                            que en razón de la misma se encuentra incluido/a en el Régimen Especial de
                            <InputTextIntegration
                                name="Declaracion.Regimen"
                                inputType={1}
                                minWidth={300}
                                req='Es necesario el Régimen'
                                disabled={false}
                            />
                        </p>

                        <p className='mb-3'>
                            Y que, para acceder a la prestación económica para el cuidado del menor enfermo y a su cargo, ha reducido su jornada de trabajo en un
                            <InputTextIntegration
                                name="Declaracion.ReduccionJornada"
                                inputType={3}
                                req='Es necesaria la reducción de jornada'
                                disabled={false}
                                modal={'La reducción de la jornada de trabajo ha de ser, al menos, de un 50%'}
                            />
                            %,
                            que iniciará con fecha
                            <InputTextIntegration
                                name="Declaracion.FechaInicio"
                                inputType={4}
                                req='Es necesaria la fecha de inicio'
                                disabled={false}
                            />

                        </p>
                    </div>

                </FieldsetContainer>

















                {/* ////////////// FINAL FORMULARIO ////////////// */}


                {/* ////////////// BLOQUEO DEL ENVIO DEL FORMULARIO //////////// */}
                <FormBotonSubmit
                    disableSubmit={bloquearEnvio}
                    onSubmit={handleSubmit(onSubmit)}
                    successCreate={successCreateDeclaracionTrabajadorCuentaPropia}
                    successUpdate={successUpdateDeclaracionTrabajadorCuentaPropiaById}
                    errorCreate={errorCreateDeclaracionTrabajadorCuentaPropia}
                    errorUpdate={errorUpdateDeclaracionTrabajadorCuentaPropiaById}
                    datosAPI={datosAPI}
                    info={info}
                    BloqueoForm={[1]}
                />


                <p className='text-info-legal paragraph  text-secondary  mb-4'>
                    Esta solicitud va a ser tramitada por medios informáticos. Los datos personales que figuran en ella serán incorporados a un fichero de base de datos para el cálculo y control de la prestación económica
                    que se le reconozca, y permanecerán bajo custodia de esta Entidad. En cualquier momento puede ejercitar su derecho de acceso, rectificación, cancelación y oposición sobre los datos incorporados al
                    fichero ( art. 5 de la ley 15/1999 de 13 diciembre de Protección de datos de carácter personal, BOE del día 14)
                </p>

                <p className='text-info-legal paragraph  text-secondary  mb-4'>
                    En cumplimiento de lo establecido en la normativa sobre de Protección de Datos de Carácter Personal, Solimat Mutua Colaboradora con la Seguridad Social nº 72 le informa que sus datos de carácter
                    personal serán objeto de tratamiento, con la finalidad del mantenimiento y cumplimiento de la relación. La base jurídica que legitima el tratamiento de sus datos es el
                    cumplimiento de una obligación legal. Sus datos serán conservados de forma indefinida en nuestra entidad para atender a las posibles responsabilidades derivadas del tratamiento. Usted
                    podrá revocar el consentimiento prestado, así como ejercitar sus derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento, o portabilidad, en su caso, remitiendo un
                    escrito a la siguiente dirección: Solimat, Mutua Colaboradora con la Seguridad Social nº 72, C/ Berna, 1, 45003, Toledo, adjuntando su NIF. Si considera que sus derechos no han sido
                    debidamente atendidos, puede contactar con nuestro delegado de protección de datos lopd@solimat.com o interponer una reclamación frente a la Agencia Española de Protección de Datos.
                </p>



            </div>
        </FormProvider>
    )
}

export default DeclaracionTrabajadorCuentaPropia
